// src/services/firebaseClient.js

import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID,
};

let firestoreClient = null;
let firestoreEmulatorConnected = false;

function isLocalhost() {
  return (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1")
  );
}

function getResolvedFirestoreDatabaseId() {
  if (isLocalhost()) {
    return (
      process.env.GATSBY_FIRESTORE_EMULATOR_DATABASE_ID || "(default)"
    ).trim();
  }

  return (process.env.GATSBY_FIRESTORE_DATABASE_ID || "sawanly").trim();
}

export function getFirebaseApp() {
  const apps = getApps();
  if (apps.length > 0) return apps[0];

  const missingRequiredConfig = ["apiKey", "authDomain", "projectId"].filter(
    (key) => !firebaseConfig[key]
  );

  if (missingRequiredConfig.length > 0) {
    throw new Error(
      `Firebase config is incomplete. Missing: ${missingRequiredConfig.join(", ")}`
    );
  }

  return initializeApp(firebaseConfig);
}

export function getAuthClient() {
  return getAuth(getFirebaseApp());
}

export function getFirestoreClient() {
  if (!firestoreClient) {
    const databaseId = getResolvedFirestoreDatabaseId();
    firestoreClient =
      databaseId === "(default)"
        ? getFirestore(getFirebaseApp())
        : getFirestore(getFirebaseApp(), databaseId);
  }

  if (isLocalhost() && !firestoreEmulatorConnected) {
    connectFirestoreEmulator(firestoreClient, "127.0.0.1", 8085);
    firestoreEmulatorConnected = true;
  }

  return firestoreClient;
}
